import { useEffect, useState } from "react";

// Helpers
import { hasViewAccess } from "@/PayPlans/helpers/Access";

// Subscriptions
import { getAssignmentsSubscriptions } from "./subscriptions";

// Contexts
import { useSubscriptions } from "@/Common/context/subscriptions/Subscriptions";

// Hooks
import { useAuthorization } from "@/Common/hooks/Authorization/Authorization";
import { useManagedPositions } from "@/Common/hooks/Positions";
import { useLocation } from "@Common/hooks/Location/useLocation";

// Layouts
import Assignments from "@/PayPlans/Layouts/Assignments";

// Custom components
import CurrentContent from "@/PayPlans/components/Assignments/Contents/Current";

type CurrentAssignmentSelectedItem = {
	_id: string;
	title: string;
	positions: string[];
	bold: boolean;
};
export default function Current() {
	const [selected, setSelected] = useState<CurrentAssignmentSelectedItem | null>(null);
	const location = useLocation();
	const { isPresentAccess } = useAuthorization();
	const { addSubscription, clearSubscriptionContext } = useSubscriptions();

	const handleSelection = (element: CurrentAssignmentSelectedItem) => {
		if (element) {
			addSubscription(["currentPayPlanAssignmentUsersByPosition", element.title], getAssignmentsSubscriptions());
			setSelected(element);
		}
	};

	const { data: tree, isLoading } = useManagedPositions({
		queryKeys: ["managedPositionsCurrentPayPlan"],
		// @ts-ignore
		onSuccess: (res: string[]) => {
			const positions = res.filter((position) => hasViewAccess(position, isPresentAccess));
			return positions.map<CurrentAssignmentSelectedItem>((position) => ({
				_id: position,
				title: position,
				bold: true,
				positions: [position],
			}));
		},
	});

	useEffect(() => {
		return () => {
			clearSubscriptionContext();
		};
	}, [clearSubscriptionContext]);

	return (
		<Assignments
			tree={tree}
			selected={selected}
			loading={isLoading}
			isLocationAvailable={Boolean(location)}
			emptyTitle={"No position selected"}
			onActionSelected={handleSelection}
		>
			<CurrentContent department={selected?.title} positions={selected?.positions || []} />
		</Assignments>
	);
}
